import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import { getBookProofsOptions, useDeleteBookProof, useUploadOrUpdateBookProof } from './model/BookProofModel';

interface BookProofActionProps {
  bookId: number;
  authors: Author[];
  variant?: 'compact';
}

export function BookProofAction({ bookId, authors }: BookProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getBookProofsOptions(bookId));
  const uploadOrUpdateMutation = useUploadOrUpdateBookProof(bookId);
  const deleteMutation = useDeleteBookProof(bookId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="book"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
